<template>
  <div>
              <div class="card">


    <div class="card-header text-center">
    <h4 style="padding-bottom:15px;" class="card-title">Download PPEs Report Data</h4>
    <p  style="padding-bottom:25px;" class="category">
      
      
    <!-- <button type="button" v-if="!loading" @click.prevent="downloadExcelFile()" class="btn btn-fill btn-danger btn-wd">Download Excel File</button></p> -->
  
    <button type="button" v-if="!loading" @click.prevent="downloadExcelFile()" class="btn btn-fill btn-wd">Download Excel File</button>
    <button type="button" v-if="loading  && !fileDownloaded" class="btn btn-wd" disabled="disabled">
      <span class="btn-label">
        <i class="fa fa-circle-o-notch fa-spin"></i>
      </span>
      Generating Excel File...
    </button>
<a v-if="fileDownloaded" class="btn btn-fill btn-wd"  :href="urlExcel">Download it!</a></p>
  </div>

<!--        <div class="card-header">
    <h4 class="card-title">All PPEs Requests</h4>
    <p class="category">Latest requests are listed first...</p>
  </div>
           <div class="card-content">
  <div style="width: 2600px">
    <vue-table-dynamic 
      :params="params" 
      ref="table"
    >
    </vue-table-dynamic>
  </div>
              </div> -->
              
              </div>
    <!--Stats cards-->
<!--     <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">All PPEs Requests</h4>
              <p class="category">Latest requests are listed first...</p>
            </div>
            <div class="card-content">
              <div class="row">
                <div class="col-md-12">
                  <div class="table-responsive">
                    <table class="table">
                      <tbody>
                      <tr>
                        <td>
                          <div class="flag">
                            <img src="static/img/flags/US.png">
                          </div>
                        </td>
                        <td>USA</td>
                        <td class="text-right">
                          2.920
                        </td>
                        <td class="text-right">
                          53.23%
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div class="flag">
                            <img src="static/img/flags/DE.png">
                          </div>
                        </td>
                        <td>Germany</td>
                        <td class="text-right">
                          1.300
                        </td>
                        <td class="text-right">
                          20.43%
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div class="flag">
                            <img src="static/img/flags/AU.png">
                          </div>
                        </td>
                        <td>Australia</td>
                        <td class="text-right">
                          760
                        </td>
                        <td class="text-right">
                          10.35%
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div class="flag">
                            <img src="static/img/flags/GB.png">
                          </div>
                        </td>
                        <td>United Kingdom</td>
                        <td class="text-right">
                          690
                        </td>
                        <td class="text-right">
                          7.87%
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div class="flag">
                            <img src="static/img/flags/RO.png">
                          </div>
                        </td>
                        <td>Romania</td>
                        <td class="text-right">
                          600
                        </td>
                        <td class="text-right">
                          5.94%
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div class="flag">
                            <img src="static/img/flags/BR.png">
                          </div>
                        </td>
                        <td>Brasil</td>
                        <td class="text-right">
                          550
                        </td>
                        <td class="text-right">
                          4.34%
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div> -->
  </div>
</template>
<script>
  import axios from 'axios'
  import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
  import Loading from 'src/components/Dashboard/Layout/LoadingMainPanel.vue'
  import VueTableDynamic from 'vue-table-dynamic'

  const random = () => {
    return parseInt(Date.now() + Math.random() * 10000000).toString(16).slice(-6)
  }
  export default {
    components: {
      StatsCard,
      ChartCard,
      CircleChartCard,
      VueTableDynamic
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data () {
      return {
        loading: false,
        fileDownloaded: false,
        urlExcel: '',
        params: {
          data: [
            ['Index', 'Request Date', 'Lack Date', 'Request ID', 'Bonnets', 'Booties', 'Don/Doff Help', 'Eye Protection', 'Gloves', 'Gowns', 'Hazmat Suits', 'N95 Masks', 'Respirator Hoods', 'Splash Guards', 'First Name', 'Last Name', 'Phone', 'email', 'Facility', 'Other Facility', 'Job Title', 'Other Job Title', 'Department', 'Comments']
          ],
          header: 'row',
          border: true,
          stripe: true,
          pagination: true,
          pageSize: 5,
          pageSizes: [5, 10, 20, 50]
        },
        ppeRequests: [],
        axios_config: {
          headers: {
            'Content-Type': 'application/json',
            'app_user_id': 'seiu_user',
            'app_user_name': 'Seiu User'
          }
        },
        statsCards: [
          {
            type: 'warning',
            icon: 'ti-server',
            title: 'Capacity',
            value: '105GB',
            footerText: 'Updated now',
            footerIcon: 'ti-reload'
          },
          {
            type: 'success',
            icon: 'ti-wallet',
            title: 'Revenue',
            value: '$1,345',
            footerText: 'Last day',
            footerIcon: 'ti-calendar'
          },
          {
            type: 'danger',
            icon: 'ti-pulse',
            title: 'Errors',
            value: '23',
            footerText: 'In the last hour',
            footerIcon: 'ti-timer'
          },
          {
            type: 'info',
            icon: 'ti-twitter-alt',
            title: 'Followers',
            value: '+45',
            footerText: 'Updated now',
            footerIcon: 'ti-reload'
          }
        ],
        earningsChart: {
          data: {
            labels: ['Jan', 'Feb', 'Mar', 'April', 'May', 'June'],
            series: [
              [230, 340, 400, 300, 570, 500, 800]
            ]
          },
          options: {
            showPoint: false,
            lineSmooth: true,
            height: '210px',
            axisX: {
              showGrid: false,
              showLabel: true
            },
            axisY: {
              offset: 40,
              showGrid: false
            },
            low: 0,
            high: 'auto',
            classNames: {
              line: 'ct-line ct-green'
            }
          }
        }

      }
    },
    methods: {
      downloadExcelFile () {
        this.loading = true
        this.$cognitoAuth.isAuthenticatedWithAttributes((err, response) => {
          if (err) {
            console.log(err)
            this.$router.replace('/login')
          } else if (!response) {
            this.user = false
            this.loggedIn = false
            this.$router.replace('/login')
          } else {
            console.log('getIdToken')
            this.$cognitoAuth.getIdToken((err, response) => {
              if (err) {
                console.log('error:')
                console.log(err)
              } else {
                console.log('got new id token')
                console.log(response)
                this.axios_config.headers.Authorization = 'Bearer ' + response
                console.log(this.axios_config)

                console.log('calling to get the ppes')
                axios.get('https://gdgpm0vbn5.execute-api.us-west-2.amazonaws.com/prod/get-excel-files', this.axios_config)
                .then((response) => {
                  console.log('the URL is:')
                  console.log(response.data)
                  this.urlExcel = response.data.url
                  // this.ppeRequests = response.data.Items
                  // console.log('the ppe requests are:')
                  // this.business = response.data
                  this.fileDownloaded = true
                })
                .catch((error) => {
                  console.log(error)
                  this.loading = false
                  // swal({
                  //   title: 'Error',
                  //   text: 'There was an error fetching business information. Please contact support.',
                  //   type: 'error',
                  //   confirmButtonClass: 'btn btn-info btn-fill',
                  //   buttonsStyling: false
                  // })
                })
              }
            })
          }
        })
      },
      fetchPpes () {
        this.$cognitoAuth.isAuthenticatedWithAttributes((err, response) => {
          if (err) {
            console.log(err)
            this.$router.replace('/login')
          } else if (!response) {
            this.user = false
            this.loggedIn = false
            this.$router.replace('/login')
          } else {
            console.log('getIdToken')
            this.$cognitoAuth.getIdToken((err, response) => {
              if (err) {
                console.log('error:')
                console.log(err)
              } else {
                console.log('got new id token')
                console.log(response)
                this.axios_config.headers.Authorization = 'Bearer ' + response
                console.log(this.axios_config)

                console.log('calling to get the ppes')
                axios.get('https://gdgpm0vbn5.execute-api.us-west-2.amazonaws.com/prod/ppe-requests', this.axios_config)
                .then((response) => {
                  console.log('fetched ppes')
                  console.log(response.data)
                  this.ppeRequests = response.data.Items
                  console.log('the ppe requests are:')
                  console.log(this.ppeRequests)
                  console.log('These are the requests')
                  console.log(this.ppeRequests.length)
                  for (let i = 0; i < this.ppeRequests.length; i++) {
                    // this.params.data.push([i + 1, `${this.ppeRequests[i].facility}`, `${this.ppeRequests[i].comments}`, `${this.ppeRequests[i].comments}`])
                    this.params.data.push([i + 1, `${this.ppeRequests[i].request_date}`, `${this.ppeRequests[i].lackDate}`, `${this.ppeRequests[i].request_id}`, `${this.ppeRequests[i].bonnetsQty}`, `${this.ppeRequests[i].bootiesQty}`, `${this.ppeRequests[i].donDoffHelpNeed}`, `${this.ppeRequests[i].eyeProtectionQty}`, `${this.ppeRequests[i].glovesQty}`, `${this.ppeRequests[i].gownsQty}`, `${this.ppeRequests[i].hazmatSuitsQty}`, `${this.ppeRequests[i].n95MasksQty}`, `${this.ppeRequests[i].respiratorHoodsQty}`, `${this.ppeRequests[i].splashGuardsQty}`, `${this.ppeRequests[i].firstName}`, `${this.ppeRequests[i].lastName}`, `${this.ppeRequests[i].memberPhone}`, `${this.ppeRequests[i].email}`, `${this.ppeRequests[i].facility}`, `${this.ppeRequests[i].otherFacility}`, `${this.ppeRequests[i].jobTitle}`, `${this.ppeRequests[i].otherJobTitle}`, `${this.ppeRequests[i].department}`, `${this.ppeRequests[i].comments}`])
                  }
                  // this.business = response.data
                  // this.loading = false
                })
                .catch((error) => {
                  console.log(error)
                  // this.loading = false
                  // swal({
                  //   title: 'Error',
                  //   text: 'There was an error fetching business information. Please contact support.',
                  //   type: 'error',
                  //   confirmButtonClass: 'btn btn-info btn-fill',
                  //   buttonsStyling: false
                  // })
                })
                // axios.get(endpoint, this.axios_config)
                // .then((response) => {
                //   console.log(response)
                //   this.reviews = response.data
                // })
                // .catch((error) => {
                //   console.log('error fetching reviews')
                //   console.log(error)
                //   this.$router.replace('/login?logout=true')
                // })
              }
            })
          }
        })
      }
    },
    created: function () {
      console.log('i am created')
      this.fetchPpes()
    },
    mounted: function () {
      // for (let i = 0; i < 100; i++) {
      //   this.params.data.push([i + 1, `${random()}`, `${random()}`, `${random()}`])
      // }

    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dashboard/PpesRequests.vue